import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import ErrorBoundary from '.';

interface IRouteErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Ponte entre hook e classe: um class component não pode chamar useLocation.
 *
 * Usa `location.key` (única por entrada do histórico) em vez de `pathname`,
 * assim renavegar para a mesma rota — ou usar o botão Voltar — também limpa
 * o erro.
 */
const RouteErrorBoundary: React.FC<IRouteErrorBoundaryProps> = ({
  children,
}) => {
  const location = useLocation();

  return <ErrorBoundary resetKey={location.key}>{children}</ErrorBoundary>;
};

export default RouteErrorBoundary;
